var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[
		'ui button',
		_vm.semanticClass,
		_vm.color,
		{ outlined: _vm.outlined },
		{ width__auto: _vm.widthAuto },
		{ bubble__button: _vm.bubbleButton },
		{ iconed: _vm.icon || _vm.lefticon },
	],attrs:{"data-testid":"button-component","type":_vm.type,"disabled":_vm.isDisabled},on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.lefticon && !_vm.loading)?_c('i',{class:['iconButton', _vm.lefticon]}):_vm._e(),_vm._v(" "+_vm._s(_vm.loading ? '' : _vm.label)+" "),(_vm.icon && !_vm.loading)?_c('i',{class:['iconButton', _vm.icon]}):_vm._e(),(_vm.loading)?_c('Spinner',{staticClass:"h-4 !opacity-100"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }